<template>
  <v-row>
    <v-col>

      <div class="requirements" v-if="(bounty.point_contest && bounty.needed_points > 0 && !isParticipating) || validDates.set">
        <h3>{{ $t('bounties.requirementsCaption') }}</h3>
        <v-list dense v-if="bounty.point_contest && !isParticipating">
          <requirement-line :fulfilled="bounty.needed_points > 0 && bounty.cr_points >= bounty.needed_points" v-if="bounty.needed_points > 0">{{ $tc('bounties.contestsRequiredPointsText', bounty.needed_points, {count: bounty.needed_points.toLocaleString()}) }}</requirement-line>

          <requirement-line v-show="validDates.set" :fulfilled="validDates.valid" class="valid-dates">
            <valid-dates :bounty="bounty" v-on:isvaliddates="isValidDates" />
          </requirement-line>

        </v-list>
      </div>

      <div class="participate">
        <v-btn rounded color="primary" @click.native.stop="participateClick" v-if="bounty.can_participate && bounty.manual_claim">
          {{$t('bounties.participate')}}
        </v-btn>

        <v-dialog v-model="participateDialog" max-width="290" persistent>
          <v-card>
            <v-card-title class="headline">{{ $t('bounties.contestTitleAlertBox') }}</v-card-title>
            <v-card-text>{{ $t('bounties.contestTextAlertBox', {neededPoints: bounty.needed_points }) }}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="primary darken-1" text @click="participateDialog = false">
                {{$t('bounties.contestCancelAlertBox')}}
              </v-btn>

              <v-btn color="primary darken-1" text @click="participate">
                {{$t('bounties.contestSubmitAlertBox')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <!--  TODO: not yet supported: highscore_contest, showRanking
      <div v-if="bounty.highscore_contest && bounty.showRanking">
        <span>{{ $t('contestDetailScreenRanking', {rank: bounty.cr_rank}) }}</span><br>
        <span v-if="bounty.cr_rank <= bounty.ranks">     -     {{ $t('bounties.youAreParticipating') }}</span>
      </div> -->


      <v-dialog v-model="errorDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('bounties.contestErrorDialogTitle') }}</v-card-title>
          <v-card-text>{{ errorDialogText }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary darken-1" text @click="errorDialog = false">
              {{$t('bounties.contestCloseAlertBox')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="successDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('bounties.contestParticipateSuccessTitle') }}</v-card-title>
          <v-card-text>{{ $t('bounties.contestParticipateSuccessText') }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary darken-1" text @click="successDialog = false" :loading="successFetchDataLoading" :disabled="successFetchDataLoading">
              {{$t('bounties.contestCloseAlertBox')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-col>
  </v-row>
</template>

<script>
  import {mdiCartPlus, mdiMinusCircle, mdiCheck} from '@mdi/js';
  import _ from 'lodash';
  import ValidDates from './ValidDates';
  import {BASE_API_URL} from '@/store'
  import Vue from 'vue'
  import {convertResponseToError} from '../../utils/error_messages';
  import {errorCodes} from '../../utils/errorCodes';
  import RequirementLine from './Requirements/RequirementLine';

  export default {
    name: 'ContestDetails',
    components: {
      ValidDates,
      RequirementLine
    },
    props: ['bounty'],
    data() {
      return {
        participateDialog: false,
        errorDialog: false,
        errorDialogText: '',
        successDialog: '',
        successFetchDataLoading: true,
        loading: false,
        icons: {
          mdiCartPlus, mdiMinusCircle, mdiCheck
        },
        validDates: {
          set: false,
          valid: false
        }
      }
    },
    computed: {
      isParticipating() {
        return _.get(this.bounty, 'is_participating', false);
      }
    },
    methods: {
      participateClick() {
        if (this.bounty.needed_points > 0 && this.bounty.consume_points) {
          this.participateDialog = true;
        } else {
          this.participate();
        }
      },
      async participate() {
        this.participateDialog = false;
        this.loading = true;

        try {
          let response = await Vue.axios.post(`${BASE_API_URL}/api/v1/clients/${this.$store.state.client_id}/bounties/${this.bounty.id}/participate/`, {});

          if (response.data.success) {
            this.successDialog = true;
            this.updateRewardsData();
          } else {
            this.errorDialog = true;
            const codeMsg = convertResponseToError(response, errorCodes);
            this.errorDialogText = this.$t(codeMsg);
          }

        } catch (error) {
          this.errorDialog = true;
          console.log('error: ', error);
          this.errorDialogText = this.$t('errorMessages.default');
        } finally {
          this.loading = false;
        }
      },
      async fetchData() {
        await this.$store.dispatch('getRewards'),
        await this.$store.dispatch('fetchCustomerRelationship')
      },
      async updateRewardsData() {
        await this.fetchData();
        this.successFetchDataLoading = false;
      },
      isValidDates(value) {
        this.validDates = value;
      }
    }
  }
</script>

<style scoped lang="scss">
  .participate {
    margin-bottom: 24px;
  }
</style>
